import { useEffect, useState, RefObject } from "react";

/**
 * Custom hook to measure container width with debounced resize handling
 * @param ref - React ref to the container element
 * @returns Current width of the container in pixels
 */
function useContainerWidth(ref: RefObject<HTMLElement>): number {
  const [width, setWidth] = useState<number>(0);

  useEffect(() => {
    if (!ref.current) return;

    const measureWidth = () => {
      if (ref.current) {
        setWidth(ref.current.offsetWidth);
      }
    };

    // Initial measurement
    measureWidth();

    // Debounced resize handler (150ms) for performance
    let timeoutId: NodeJS.Timeout;
    const handleResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(measureWidth, 150);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("resize", handleResize);
    };
  }, [ref]);

  return width;
}

export default useContainerWidth;
